import { useEffect, lazy, Suspense } from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box } from '@mui/material';

import { Container } from '~/content/components/Container';
// import Delivery from './delivery';
import Hero from './hero';
import Reviews from './reviews';

// import Contact from '~/content/components/Contact';
// import Partners from './partners';
// import Benefits from './benefits';
// import Customization from './customization';
const Contact = lazy(() => import('~/content/components/Contact'));
const Partners = lazy(() => import('./partners.tsx'));
const Benefits = lazy(() => import('./benefits.tsx'));
const Customization = lazy(() => import('./customization.tsx'));

import Customer from './customer';
// import { trackEvent } from '~/utils/plausible';

import { trackPageview } from '~/utils/plausible';
import { useTranslation } from 'react-i18next';

const Applications = (): JSX.Element => {
	let { t } = useTranslation(['applications']);

	const theme = useTheme();
	useEffect(() => {
		trackPageview();
	}, []);

	const size = '3px';
	const gap = '16px';

	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true,
	});

	return (
		<>
			<Box
				position={'relative'}
				// sx={{
				//   backgroundColor: theme.palette.alternate.main,
				//   marginTop: -13,
				//   paddingTop: 13,
				// }}
				sx={{
					backgroundColor: theme.palette.alternate.main,
					// backgroundImage: `linear-gradient(120deg, ${theme.palette.background.paper} 0%, ${theme.palette.alternate.main} 100%)`,
					//? needs to be "-15" bc of older top-topbar
					// marginTop: -15,
					//? padding first element after "Topbar"
					// paddingTop: 18,
				}}
			>
				<Container>
					<Hero />
				</Container>

				<Container>
					<Reviews />
				</Container>
			</Box>

			<Container position='relative' zIndex={2} name='start-dev'>
				<Customization />
			</Container>

			<Box bgcolor={'alternate.main'}>
				<Container>
					<Partners />
				</Container>
			</Box>

			<Container>
				<Benefits />
			</Container>

			<Box bgcolor={'alternate.main'}>
				<Container marginTop={isMd ? 4 : 6} marginBottom={isMd ? 0 : 0}>
					<Customer />
				</Container>
			</Box>

			<Box
				pt={{ xs: 5, md: 9 }}
				pb={{ xs: 5, md: 9 }}
				bgcolor={theme.palette.primary.light}
				sx={{
					position: 'relative',

					'&::after': {
						position: 'absolute',
						content: '""',
						// width: '25%',
						zIndex: 1,
						top: 0,
						width: isMd ? '25%' : '0%',
						left: '5%',
						height: '93%',
						inset: gap,
						WebkitMask: `
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0,
									conic-gradient(at ${size} ${size},#0000 75%,#000 0) 0 0;
									`,
						WebkitMaskSize: `calc(${size} + ${gap}) calc(${size} + ${gap})`,
						background: theme.palette.primary.main,
						opacity: 0.1,
					},
				}}
			>
				<Container>
					<Contact leftButtonText={t('mini_contact_button_1')} />
				</Container>
			</Box>
		</>
	);
};

export default Applications;
